import { render, staticRenderFns } from "./radioGroup.vue?vue&type=template&id=de2c3d48&scoped=true&"
import script from "./radioGroup.vue?vue&type=script&lang=js&"
export * from "./radioGroup.vue?vue&type=script&lang=js&"
import style0 from "./radioGroup.vue?vue&type=style&index=0&id=de2c3d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2c3d48",
  null
  
)

export default component.exports